export enum RivvyState {
  LIMITED = 'limited',
  WARN = 'warn',
  UNLIMITED = 'unlimited',
}

export interface RivvyLimits {
  remaining: number; // Remaining dollar limit for the account
  limit: number; // Total dollar limit for the account
  state: RivvyState; // Current state of the account's usage
}

export enum RivvyHosts {
  BEDROCK = 'bedrock',
  OPENAI = 'openai',
  LOCAL = 'local',
}

// this is aligned with langchain
export enum RivvyMessageType {
  HUMAN = 'human', // 'user' in bedrock speak
  AI = 'ai', // 'assistant' in bedrock speak
}

export interface RivvyPostQuery {
  message: RivvyMessage['content'];
  threadId?: RivvyThread['id'];
}

// Interface for rivvy_thread table
export interface RivvyThread {
  id: number;
  uuid: string;
  accountId: number;
  userId: number;
  title: string;
  prompt?: string;
  model?: string;
  created: string; // ISO timestamp
  modified: string; // ISO timestamp
  deleted?: string | null; // ISO timestamp
}

// Interface for rivvy_message table
export interface RivvyMessage {
  id?: bigint;
  rivvyThreadId?: bigint;
  source: RivvyMessageType;
  content: string;
  inputTokenCount?: number;
  outputTokenCount?: number;
  is_good?: boolean;
  is_bad?: boolean;
  response_metadata?: Record<string, any>; // JSONB type
  created?: string; // ISO timestamp
  loading?: boolean;
}

export type ChunkData =
  | {
      type: 'message_start';
      message: {
        id: string;
        type: string;
        role: string;
        model: string;
        content: any[];
        stop_reason: string | null;
        stop_sequence: string | null;
        usage: {
          input_tokens: number;
          cache_creation_input_tokens: number;
          cache_read_input_tokens: number;
          output_tokens: number;
        };
      };
    }
  | {
      type: 'content_block_start';
      index: number;
      content_block: {
        type: string;
        text: string;
      };
    }
  | {
      type: 'content_block_delta';
      index: number;
      delta: {
        type: string;
        text: string;
      };
    }
  | {
      type: 'content_block_stop';
      index: number;
    }
  | {
      type: 'message_delta';
      delta: {
        stop_reason: string;
        stop_sequence: string | null;
      };
      usage: {
        output_tokens: number;
      };
    }
  | {
      type: 'message_stop';
      'amazon-bedrock-invocationMetrics': {
        inputTokenCount: number;
        outputTokenCount: number;
        invocationLatency: number;
        firstByteLatency: number;
      };
    };
